export enum EInstrumentType {
  Unknown = 0,
  RI360 = 7,
  RI1000 = 4,
}

export const instrumentTypeStrings = [
  EInstrumentType[EInstrumentType.Unknown],
  EInstrumentType[EInstrumentType.RI360],
  EInstrumentType[EInstrumentType.RI1000],
];
